var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "104.80000000000007 52.307692307692264 812.2000000000002 588.4615384615387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    width: "812.2000000000002px",
    height: "588.4615384615387px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Master/Scene/1 Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(-3 0) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background/Wireframe"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twisted Leaf",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M807.581 225.208C807.098 224.857 805.952 224.732 805.419 224.627C803.203 224.19 800.919 224 798.66 224C791.692 224.01 784.612 224.694 777.76 225.878C773.41 226.629 768.151 229.157 763.823 227.784C756.284 225.392 748.665 225.509 741.512 228.924C734.973 232.047 730.008 237.979 727.111 244.387C726.674 245.355 724.901 248.915 724.399 251.316C724.184 251.806 723.978 252.301 723.792 252.802C723.265 254.226 722.792 255.675 722.352 257.127C722.164 257.746 721.692 259.114 722.253 259.378C721.356 261.032 720.562 262.736 719.9 264.495C717.976 269.613 715.871 275.226 715.195 280.649C714.945 282.657 714.935 284.677 715.168 286.69C715.283 287.684 715.235 289.684 715.91 290.44C717.341 292.045 718.076 289.798 717.914 288.728C716.682 280.574 719.062 272.916 721.881 265.251C723.705 260.295 726.701 255.76 730.057 251.653C732.773 248.329 735.687 245.712 739.41 243.508C743.964 240.813 748.832 238.634 753.655 236.448C756.827 235.01 760.003 233.611 763.264 232.372C763.989 232.096 765.13 231.389 765.934 231.387C767.634 231.381 770.043 232.635 771.685 233.101C777.087 234.637 782.557 236.602 788.14 237.386C791.72 237.89 795.075 237.323 798.424 236.13C798.766 236.009 799.339 235.696 800.042 235.249C802.528 234.292 804.88 233.089 806.928 231.353C808.108 230.353 809.178 229.06 810.155 227.877C810.447 227.524 810.576 227.118 810.58 226.733C810.802 226.617 810.948 226.482 810.982 226.324C811.225 225.16 809.004 225.139 807.581 225.208",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.164 257.594C795.063 256.923 791.639 256.974 788.481 257.03C771.541 257.258 754.907 265.205 744.081 277.903C734.864 288.714 732.33 302.154 730.509 315.74C730.329 317.089 730.252 318.429 730.15 319.781C730.128 320.071 730.095 320.33 730.06 320.574C729.344 321.208 728.969 321.948 729.392 322.76C727.815 326.181 726.481 329.688 725.336 333.305C721.966 343.953 718.538 354.803 720.649 366C721.143 359.838 722.181 353.538 723.422 347.477C723.493 347.129 723.57 346.784 723.65 346.44C723.659 346.404 723.666 346.368 723.675 346.332C724.114 344.476 724.685 342.676 725.379 340.904C725.387 340.884 725.394 340.865 725.401 340.846C725.493 340.613 725.59 340.381 725.687 340.149C725.885 339.669 726.09 339.189 726.306 338.713C726.38 338.55 726.45 338.386 726.518 338.221C727.529 335.765 727.956 332.999 728.862 330.458C729.078 329.88 729.305 329.305 729.542 328.732C729.556 328.699 729.57 328.665 729.585 328.631C730.226 327.091 730.935 325.569 731.684 324.063C732.092 323.76 732.309 323.007 732.66 322.323C732.733 322.189 733.301 321.29 733.47 320.772C733.911 319.926 734.351 319.08 734.796 318.236C734.782 318.241 734.769 318.245 734.756 318.25C735.2 317.439 735.646 316.632 736.089 315.828C736.186 315.651 736.285 315.474 736.383 315.297C736.542 315.015 736.701 314.733 736.859 314.452C738.343 311.821 739.916 309.242 741.55 306.696C742.133 305.787 743.527 304.484 743.794 303.463C743.803 303.425 743.806 303.39 743.812 303.354C747.357 298.419 751.439 293.868 756.333 290.262C755.742 290.896 754.484 293.047 754.151 293.472C753.134 294.776 752.029 295.99 750.92 297.218C748.935 299.419 746.996 301.689 745.273 304.09C742.123 308.48 739.405 313.101 736.836 317.814C736.811 317.842 736.785 317.868 736.762 317.897C735.47 319.474 734.658 321.858 733.728 323.662C737.407 321.974 741.474 320.874 745.25 319.375C749.014 317.88 752.677 316.216 756.213 314.262C760.912 311.664 765.787 308.732 770.227 305.413C775.316 302.285 779.592 297.98 783.366 293.463C787.832 288.117 791.925 282.726 794.456 276.235C795.699 273.046 796.677 269.721 797.257 266.356C797.282 266.21 797.315 266.051 797.35 265.885C797.943 264.723 798.474 263.535 798.919 262.32C799.626 260.392 801.295 258.272 798.164 257.594",
    fill: "#56919C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M826.291 364.744C824.486 360.648 820.661 357.48 816.904 355.133C802.232 345.965 785.03 342.805 768.034 343.492C758.721 343.869 749.335 345.894 740.488 348.581C735.38 350.132 730.421 352.163 725.978 355.093C722.98 357.07 720.307 359.412 717.857 362.02C714.871 365.198 711.988 368.543 709.425 372.069C708.416 373.458 702.759 380.638 705.086 382.273C704.953 382.454 704.837 382.633 704.75 382.805C694.399 387.735 685.164 395.324 676.477 402.56C668.917 408.858 661.6 415.4 654.968 422.657C646.237 432.213 638.085 442.356 630.623 452.92C629.019 455.19 627.456 457.487 625.905 459.795C624.582 461.763 623.258 463.731 621.937 465.7C620.455 467.907 618.439 470.253 617.397 472.715C616.49 474.86 618.358 475.617 619.645 473.723C621.199 471.435 622.652 469.078 624.22 466.796C626.301 463.768 628.386 460.743 630.483 457.726C645.048 436.769 662.326 417.949 682.408 402.105C690.535 395.693 698.819 389.992 707.96 385.075C715.997 380.752 724.678 377.129 733.183 374.017C741.448 370.994 749.81 368.22 758.546 366.741C765.636 365.542 772.855 365.148 780.061 365.088C789.214 365.011 798.291 365.027 807.383 366.26C812.109 366.9 816.796 367.759 821.509 368.485C822.357 368.615 823.248 368.785 824.099 368.854C826.937 369.085 827.274 366.974 826.291 364.744",
    fill: "#C1DEE2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.211 281.695C263.843 282.768 262.501 283.864 261.192 285.004C260.194 285.873 258.429 286.913 258.071 288.23C257.698 289.598 258.874 290.879 259.802 291.706C264.712 296.082 270.241 299.04 277.045 299.531C287.521 300.289 296.639 297.698 305.728 292.6C312.113 289.018 316.342 283.721 317.266 276.568C324.87 279.629 332.224 283.847 338.474 289.025C341.557 291.58 344.213 294.411 346.67 297.548C348.243 299.558 349.765 301.6 351.178 303.721C351.792 304.642 352.416 306.276 353.429 306.807C354.619 307.43 356.057 306.453 355.998 305.172C355.949 304.106 354.76 302.869 354.204 301.997C353.281 300.549 352.344 299.111 351.357 297.703C349.76 295.424 348.109 293.176 346.309 291.043C342.263 286.251 337.116 282.292 331.779 278.915C321.542 272.438 310.307 268.358 297.851 268.012C290.192 267.8 283.749 270.334 277.199 274.119C273.121 276.475 268.911 278.792 265.211 281.695",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leaf",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.536 282.007C339.574 273.792 331.585 265.68 322.69 258.446C317.448 254.183 311.923 250.307 306.513 246.265C307.137 246.813 307.749 247.377 308.347 247.955C306.658 246.806 304.447 246.157 302.657 245.093C300.659 243.907 298.75 242.551 296.878 241.183C293.222 238.514 289.622 235.795 285.865 233.266C281.678 230.448 277.34 227.844 273.082 225.132C269.469 222.83 265.812 220.311 261.946 218.43C259.839 217.404 257.727 216.189 255.612 215.119C254.904 214.761 247.72 210.216 247.738 210.203C248.135 209.903 251.75 211.605 252.309 211.834C253.942 212.502 255.504 213.302 257.074 214.098C256.213 212.395 255.53 210.606 255.159 208.722C255.044 208.141 254.125 203.908 254.596 203.553C254.83 203.376 257.122 210.948 257.24 211.676C257.335 212.268 257.321 213.119 257.514 213.679C257.826 214.584 257.811 214.311 258.498 214.82C259.757 215.754 261.429 216.338 262.792 217.118C263.527 217.529 265.803 219.16 267.174 219.625C271.322 221.643 275.526 224.748 279.467 227.327C278.433 225.379 277.645 223.342 277.071 221.208C276.935 220.702 275.462 216.156 275.819 215.886C276.221 215.583 279.028 222.525 279.194 223.182C279.503 224.403 279.567 225.761 279.954 226.949C280.378 228.253 281.703 228.715 282.896 229.475C287.288 232.271 291.529 235.241 295.699 238.348C300.249 230.24 295.003 220.449 290.581 213.645C287.394 208.742 283.103 204.538 278.572 200.869C272.526 195.971 265.608 192.058 258.699 188.479C250.648 184.308 241.947 181.724 232.901 180.531C228.169 179.906 223.329 179.924 218.55 180.124C216.215 180.222 213.974 180.531 211.737 181.294C210.728 181.639 209.754 182.072 208.804 182.558C208.083 182.927 206.337 183.317 205.922 183.867C202.507 188.321 200.76 192.759 201.027 198.355C201.279 203.653 202.949 208.954 205.215 213.68C207.739 218.942 210.985 223.718 215.23 227.726C218.469 230.785 222.091 233.446 225.688 236.073C238.482 245.416 254.704 253.541 271.275 251.454C276.639 250.778 281.741 248.899 286.509 246.345C287.632 245.743 288.749 245.134 289.809 244.423C290.524 243.944 292.436 241.786 293.155 241.707C294.14 241.6 296.264 243.609 297.189 244.22C304.217 248.869 311.062 253.769 317.763 258.868C324.892 264.293 331.672 270.087 338.252 276.153C341.05 278.734 343.831 281.32 346.549 283.987C347.181 284.607 348.728 286.892 349.875 286.995C350.601 287.061 351.09 286.44 350.986 285.768C350.806 284.598 348.351 282.849 347.536 282.007",
    fill: "#C1DEE2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mobile3",
    clipPath: "url(#clip0_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 16_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.14 310C274.815 310 273.494 310.027 272.171 310.095C271.162 310.148 269.621 309.939 268.768 310.568C267.881 311.221 267.942 312.557 268.081 313.501C268.813 318.493 270.6 322.919 274.339 326.456C280.096 331.901 286.695 334.668 294.504 335.9C299.99 336.766 305.054 335.564 309.092 331.663C312.043 337.139 314.281 343.199 315.404 349.315C315.958 352.333 316.127 355.315 316.03 358.388C315.967 360.356 315.859 362.32 315.648 364.279C315.556 365.13 315.122 366.418 315.455 367.223C315.846 368.167 317.165 368.259 317.757 367.453C318.25 366.783 318.16 365.466 318.261 364.673C318.429 363.355 318.584 362.036 318.695 360.712C318.876 358.569 319.009 356.42 319 354.268C318.977 349.435 317.902 344.583 316.432 339.995C313.612 331.192 309.037 323.369 301.921 317.231C297.545 313.457 292.537 311.929 286.856 311.108C283.318 310.597 279.723 310 276.14 310",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M296.571 345C282.272 345 272.642 356.524 268.089 368.502C266.372 373.016 265.97 377.974 265.308 382.714C265.096 384.236 265.175 386.554 264.557 387.909C264.333 388.401 263.819 388.577 264.065 389.247C264.214 389.652 264.505 389.901 264.944 389.981C265.843 390.147 267.115 389.167 267.886 388.781C274.282 385.573 278.484 380.613 281.912 374.545C284.038 370.784 286.194 366.879 287.456 362.75C288.227 360.227 288.676 357.571 288.94 354.954C289.044 353.923 289.144 352.868 289.138 351.832C289.132 350.803 288.653 350.259 288.309 349.364C293.08 347.558 298.466 347.066 303.299 348.937C307.769 350.668 311.482 354.013 313.561 358.216C314.101 359.308 314.518 360.46 314.821 361.636C315.02 362.406 315.029 363.404 315.398 364.1C316.29 365.788 318.168 364.66 317.988 363.089C317.485 358.708 314.979 354.309 311.775 351.263C307.734 347.421 302.258 345 296.571 345",
    fill: "#89C5CC"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    x: 312,
    y: 118,
    width: 143,
    height: 271,
    rx: 8,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Touch",
    cx: 383,
    cy: 358,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Lens",
    cx: 370,
    cy: 134,
    r: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sensor",
    x: 377,
    y: 132,
    width: 21,
    height: 4,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    clipPath: "url(#clip1_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row",
    clipPath: "url(#clip2_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_2",
    x: 328,
    y: 146,
    width: 110,
    height: 48,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff",
    clipPath: "url(#clip3_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 337,
    y: 160.4,
    width: 52,
    height: 7.2,
    rx: 3,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_2",
    x: 337,
    y: 172.4,
    width: 34.9041,
    height: 7.2,
    rx: 3,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    cx: 426.244,
    cy: 170,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    cx: 426.244,
    cy: 170,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_2",
    clipPath: "url(#clip4_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background_2",
    x: 328,
    y: 202,
    width: 110,
    height: 37,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    clipPath: "url(#clip5_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 367,
    y: 213.1,
    width: 52,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name_2",
    x: 367,
    y: 222.35,
    width: 34.9041,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    cx: 349,
    cy: 220.5,
    r: 12,
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row_3",
    clipPath: "url(#clip6_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_3",
    x: 328,
    y: 247,
    width: 110,
    height: 37,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_2",
    clipPath: "url(#clip7_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_3",
    x: 337,
    y: 258.1,
    width: 52,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_4",
    x: 337,
    y: 267.35,
    width: 34.9041,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_3",
    cx: 426.244,
    cy: 265.5,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_2",
    cx: 426.244,
    cy: 265.5,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_4",
    clipPath: "url(#clip8_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background_4",
    x: 328,
    y: 292,
    width: 110,
    height: 37,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text_2",
    clipPath: "url(#clip9_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name_3",
    x: 367,
    y: 303.1,
    width: 52,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name_4",
    x: 367,
    y: 312.35,
    width: 34.9041,
    height: 5.55,
    rx: 2.775,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar_2",
    cx: 349,
    cy: 310.5,
    r: 12,
    fill: "#C5CFD6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Web",
    clipPath: "url(#clip10_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_4",
    x: 426,
    y: 164,
    width: 302,
    height: 311,
    rx: 8,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background_5",
    x: 651,
    y: 203,
    width: 63,
    height: 73,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile Info"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Avatar_3",
    cx: 682.5,
    cy: 230.462,
    rx: 14.4,
    ry: 14.4615,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name_5",
    x: 660,
    y: 248.539,
    width: 45,
    height: 5.42308,
    rx: 2.71154,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name_6",
    x: 667.2,
    y: 257.577,
    width: 30.6,
    height: 5.42308,
    rx: 2.71154,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Header",
    d: "M426 172C426 167.582 429.582 164 434 164H720C724.418 164 728 167.582 728 172V188H426V172Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttons"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    cx: 439,
    cy: 178,
    r: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons_2",
    cx: 451,
    cy: 178,
    r: 4,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons_3",
    cx: 463,
    cy: 178,
    r: 4,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Components",
    clipPath: "url(#clip11_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background_6",
    x: 651,
    y: 283,
    width: 63,
    height: 174,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rows_2",
    clipPath: "url(#clip12_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    x: 669,
    y: 301,
    width: 27,
    height: 23,
    rx: 4,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data_2",
    x: 669,
    y: 332,
    width: 27,
    height: 22,
    rx: 4,
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data_3",
    x: 669,
    y: 362,
    width: 27,
    height: 22,
    rx: 4,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data_4",
    x: 669,
    y: 422,
    width: 27,
    height: 22,
    rx: 4,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data_5",
    x: 669,
    y: 392,
    width: 27,
    height: 22,
    rx: 4,
    fill: "#C5CFD6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rows_3",
    clipPath: "url(#clip13_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row_5",
    clipPath: "url(#clip14_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_5",
    x: 442,
    y: 208,
    width: 192,
    height: 42,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_3",
    clipPath: "url(#clip15_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_5",
    x: 451,
    y: 220.6,
    width: 134,
    height: 6.3,
    rx: 3,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_6",
    x: 451,
    y: 231.1,
    width: 89.9452,
    height: 6.3,
    rx: 3,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_7",
    cx: 613.481,
    cy: 229,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_3",
    cx: 613.481,
    cy: 229,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_6",
    clipPath: "url(#clip16_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_6",
    x: 442,
    y: 258,
    width: 192,
    height: 34,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_4",
    clipPath: "url(#clip17_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_7",
    x: 451,
    y: 268.2,
    width: 134,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_8",
    x: 451,
    y: 276.7,
    width: 89.9452,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_8",
    cx: 613.481,
    cy: 275,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_4",
    cx: 613.481,
    cy: 275,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_7",
    clipPath: "url(#clip18_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_7",
    x: 442,
    y: 300,
    width: 192,
    height: 34,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_5",
    clipPath: "url(#clip19_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_9",
    x: 451,
    y: 310.2,
    width: 134,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_10",
    x: 451,
    y: 318.7,
    width: 89.9452,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_9",
    cx: 613.481,
    cy: 317,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_5",
    cx: 613.481,
    cy: 317,
    r: 3,
    fill: "#AFB9C5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_8",
    clipPath: "url(#clip20_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_8",
    x: 442,
    y: 426,
    width: 192,
    height: 34,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_6",
    clipPath: "url(#clip21_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_11",
    x: 451,
    y: 436.2,
    width: 134,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_12",
    x: 451,
    y: 444.7,
    width: 89.9452,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_10",
    cx: 613.481,
    cy: 443,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_6",
    cx: 613.481,
    cy: 443,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_9",
    clipPath: "url(#clip22_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_9",
    x: 442,
    y: 384,
    width: 192,
    height: 34,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_7",
    clipPath: "url(#clip23_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_13",
    x: 451,
    y: 394.2,
    width: 134,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_14",
    x: 451,
    y: 402.7,
    width: 89.9452,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_11",
    cx: 613.481,
    cy: 401,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_7",
    cx: 613.481,
    cy: 401,
    r: 3,
    fill: "#F2F2F2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row_10",
    clipPath: "url(#clip24_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_10",
    x: 442,
    y: 342,
    width: 192,
    height: 34,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text Stuff_8",
    clipPath: "url(#clip25_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label_15",
    x: 451,
    y: 352.2,
    width: 134,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label_16",
    x: 451,
    y: 360.7,
    width: 89.9452,
    height: 5.1,
    rx: 2.55,
    fill: "#C7D1D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check_8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background_12",
    cx: 613.481,
    cy: 359,
    r: 7,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator_8",
    cx: 613.481,
    cy: 359,
    r: 3,
    fill: "#F2F2F2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.915 395.219C179.66 423.452 199.162 450.79 210.874 481.659C210.402 478.02 209.902 474.385 209.342 470.756C206.37 451.516 202.677 432.416 198.795 413.339C196.819 403.626 194.729 393.949 192.585 384.272C191.431 379.075 190.292 373.874 189.116 368.682C188.831 367.423 188.586 365.226 188.229 363C199.611 400.539 210.587 438.105 218.616 476.546C219.669 481.591 220.566 486.627 221.301 491.655C221.552 490.508 221.799 489.361 222.07 488.217C225.318 474.507 230.191 460.905 235.994 448.086C238.767 441.955 241.953 435.959 245.705 430.371C248.044 426.888 253.561 422.748 255.694 419.181C244.024 440.694 239.81 467.611 233.071 491C231.427 496.707 229.772 502.405 228.15 508.113C238.312 487.631 254.079 470.803 276 463.51C249.465 481.131 233.549 511.989 222.824 543.549C222.789 543.923 222.747 544.298 222.711 544.673C225.867 538.653 229.842 533.208 235.23 529.394C246.762 521.23 259.554 523.609 270.741 530.612C261.961 525.003 246.094 530.11 238.707 535.811C233.419 539.892 228.9 545.366 224.975 550.708C224.035 551.988 222.752 553.482 221.396 555.076C219.496 567.473 216.399 579.785 212.015 592C212.739 588.494 212.215 582.887 212.416 580.273C212.438 579.991 212.456 579.707 212.477 579.425C211.811 582.1 211.167 584.744 210.547 587.345C211.779 582.381 212.449 577.199 212.972 571.964C213.107 569.714 213.238 567.464 213.377 565.214C213.333 560.944 213.158 556.657 212.862 552.363C211.812 548.19 210.637 544.254 209.668 540.981C206.172 529.17 201.046 517.854 194.736 507.298C188.98 497.665 182.089 488.939 174.134 481.047C169.846 476.794 165.358 472.744 160.933 468.637C159.333 467.152 156.473 463.502 154 461.599C172.013 471.58 190.554 482.378 203.695 498.459C202.154 492.514 200.481 486.652 198.711 480.908C189.731 451.764 178.392 421.56 162.915 395.219Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Base",
    cx: 218,
    cy: 584.5,
    rx: 37,
    ry: 29.5,
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Graph"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    x: 807,
    y: 133,
    width: 5,
    height: 22,
    rx: 2.5,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_2",
    x: 820,
    y: 118,
    width: 5,
    height: 37,
    rx: 2.5,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_3",
    x: 833,
    y: 111,
    width: 5,
    height: 44,
    rx: 2.5,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_4",
    x: 845,
    y: 118,
    width: 5,
    height: 37,
    rx: 2.5,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value_5",
    x: 858,
    y: 104,
    width: 5,
    height: 51,
    rx: 2.5,
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pie Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 348.941C116 339.075 124.102 331 134 331V348.941L121.699 362C118.2 358.807 116 354.124 116 348.941Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.585 348H152C152 352.699 150.058 357.102 146.988 360.301C143.612 363.8 138.804 366 133.585 366C128.778 366 124.377 364.102 121 361.101L133.585 348Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 349C152 339.102 143.898 331 134 331V349H152ZM125 331L132.2 347.2L116 340C117.602 335.801 121.199 332.602 125 331Z",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886.135 393.841C884.398 395.643 881.938 396.775 879.201 396.775C873.943 396.775 869.681 392.622 869.681 387.5C869.681 382.378 873.943 378.225 879.201 378.225V361C864.243 361 852 372.928 852 387.5C852 402.072 864.243 414 879.201 414C887.059 414 894.16 410.762 899 405.61L886.135 393.841Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879 361V378.55C884.219 378.55 888.45 382.781 888.45 388H906C906 373.153 893.847 361 879 361Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M887.756 388C887.756 390.981 886.285 393.631 884 395.342L895.24 409C901.783 404.11 906 396.531 906 388H887.756Z",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chart_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Value_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M752.872 115.406C751.505 116.8 749.568 117.675 747.414 117.675C743.275 117.675 739.919 114.463 739.919 110.5C739.919 106.537 743.275 103.325 747.414 103.325V90C735.638 90 726 99.227 726 110.5C726 121.773 735.638 131 747.414 131C753.599 131 759.189 128.495 763 124.51L752.872 115.406Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M747 90V103.65C751.059 103.65 754.35 106.941 754.35 111H768C768 99.4521 758.548 90 747 90Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Value_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M754.731 111C754.731 113.271 753.662 115.29 752 116.594L760.175 127C764.933 123.275 768 117.5 768 111H754.731Z",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.007 112.986C192.003 112.996 191.999 113.006 191.993 113.018C191.999 113.008 192.007 112.968 192.007 112.986",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.998 113.001C191.998 113.003 191.996 113.007 191.996 113.011C191.996 113.001 192.014 112.971 191.998 113.001",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.067 112.832C192.053 112.872 192.035 112.91 192.019 112.95C192.027 112.93 192.035 112.914 192.043 112.894C191.835 113.414 191.967 113.076 192.067 112.832",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.022 112.953C192.014 112.971 192.006 112.991 191.998 113.009C191.94 113.121 192.022 112.953 192.022 112.953",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.999 113.002C191.999 113 191.999 113 192.001 112.998C191.999 113 191.999 113 191.999 113.002",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.99 113.016C191.978 113.04 192.046 112.924 191.99 113.016Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.998 113.002L192.002 112.998C192 113 192 113.002 191.998 113.002",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo Background",
    x: 149,
    y: 66,
    width: 86,
    height: 57,
    rx: 4,
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.2 82L156 123H206.4L181.2 82Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.95 92.9333L183.9 123H228L205.95 92.9333Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    cx: 216,
    cy: 85,
    r: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 35_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M770.993 495.986C770.997 495.996 771.001 496.006 771.007 496.018C771.001 496.008 770.993 495.968 770.993 495.986",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.002 496.001C771.002 496.003 771.004 496.007 771.004 496.011C771.004 496.001 770.986 495.971 771.002 496.001",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M770.933 495.832C770.947 495.872 770.965 495.91 770.981 495.95C770.973 495.93 770.965 495.914 770.957 495.894C771.165 496.414 771.033 496.076 770.933 495.832",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M770.978 495.953C770.986 495.971 770.994 495.991 771.002 496.009C771.06 496.121 770.978 495.953 770.978 495.953",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 45_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.001 496.002C771.001 496 771.001 496 770.999 495.998C771.001 496 771.001 496 771.001 496.002",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.01 496.016C771.022 496.04 770.954 495.924 771.01 496.016Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 49_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M771.002 496.002L770.998 495.998C771 496 771 496.002 771.002 496.002",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo Background_2",
    width: 142,
    height: 94,
    rx: 4,
    transform: "matrix(-1 0 0 1 842 419)",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M789.274 446L830.329 513H748.219L789.274 446Z",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mountains_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M746.944 463.947L783.239 513H710.649L746.944 463.947Z",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sun_2",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "matrix(-1 0 0 1 745 437)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 191,
    height: 272,
    fill: "white",
    transform: "translate(264 118)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 183,
    fill: "white",
    transform: "translate(328 146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 48,
    fill: "white",
    transform: "translate(328 146)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 19.2,
    fill: "white",
    transform: "translate(337 160.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 37,
    fill: "white",
    transform: "translate(328 202)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 14.8,
    fill: "white",
    transform: "translate(367 213.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 37,
    fill: "white",
    transform: "translate(328 247)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 14.8,
    fill: "white",
    transform: "translate(337 258.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 37,
    fill: "white",
    transform: "translate(328 292)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 14.8,
    fill: "white",
    transform: "translate(367 303.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 311,
    fill: "white",
    transform: "translate(426 164)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 174,
    fill: "white",
    transform: "translate(651 283)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 143,
    fill: "white",
    transform: "translate(669 301)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 252,
    fill: "white",
    transform: "translate(442 208)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 42,
    fill: "white",
    transform: "translate(442 208)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 16.8,
    fill: "white",
    transform: "translate(451 220.6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 34,
    fill: "white",
    transform: "translate(442 258)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 13.6,
    fill: "white",
    transform: "translate(451 268.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 34,
    fill: "white",
    transform: "translate(442 300)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 13.6,
    fill: "white",
    transform: "translate(451 310.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 34,
    fill: "white",
    transform: "translate(442 426)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 13.6,
    fill: "white",
    transform: "translate(451 436.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 34,
    fill: "white",
    transform: "translate(442 384)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 13.6,
    fill: "white",
    transform: "translate(451 394.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 34,
    fill: "white",
    transform: "translate(442 342)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_410_5451ea72e470-6635-4bc5-9ee3-de01a9abf139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 13.6,
    fill: "white",
    transform: "translate(451 352.2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Master/Pose/Standing",
    transform: "translate(374 214) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master/Pose/Standing"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front",
    transform: "translate(82 0) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head/Front/Long"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair Back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5 27C60.6259 27 51 36.6259 51 48.5V69.5C51 80.5658 59.3599 89.679 70.1086 90.8685C70.1114 90.9197 70.1143 90.971 70.1173 91.0225H99.1173C103.701 86.5438 99.209 57.9923 95.762 45.2902C94.2125 34.9385 85.2833 27 74.5 27H72.5Z",
    fill: "#b58143"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9354 75.2443C80.411 79.1475 86.7736 81.0333 89.7603 80.2635C97.2496 78.333 97.9382 50.9351 92.1433 40.1339C86.3485 29.3328 56.5583 24.625 55.0568 46.0255C54.5356 53.4529 57.6544 60.0814 62.2623 65.4901L54 104H78L73.9354 75.2443Z",
    fill: "#d4a181"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair Front",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8812 46.1504C52.578 45.4614 53.2522 44.7947 53.9211 44.1981L53.8889 43.4207C53.8889 43.4207 61.4214 28 73.0014 28C84.5711 28 88.23 33.3787 91.3403 37.9508L91.3487 37.9631C89.7218 43.5452 84.8187 45.8037 79.2736 48.3579C76.8866 49.4574 74.3806 50.6117 71.9657 52.1095C71.0199 51.341 69.8137 50.8804 68.5 50.8804C65.4624 50.8804 63 53.3428 63 56.3804C63 59.418 65.4624 61.8804 68.5 61.8804C68.5838 61.8804 68.6671 61.8785 68.75 61.8748C69.8557 73.7528 69.4127 87.3173 66.1173 90.5371H37.1173C36.2848 76.0731 40.0264 71.947 43.8498 67.7307C47.4474 63.7635 51.1173 59.7166 51.1173 46.9028C51.3754 46.6506 51.6298 46.3991 51.8812 46.1505L51.8812 46.1504Z",
    fill: "#b58143"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Lower Body/Standing",
    transform: "translate(0 187) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lower Body/Standing/Jogging"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130 0L204.306 124.227L260.015 229.25H272.014L178.674 0L130 0Z",
    fill: "#ba8b72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right [shoe]"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.45 223.284C254.378 222.813 253.104 223.29 252.705 224.391C251.977 226.398 251 229.409 251 231.106C251 233.811 251.901 239 251.901 239C255.039 239 308.303 239 308.303 239C308.303 239 310.502 231.732 305.765 231.152C301.028 230.573 297.895 230.106 297.895 230.106L271.68 218.419C271.165 218.189 270.563 218.43 270.348 218.951L268.663 223.039C268.663 223.039 264.278 225.085 261.537 225.085C259.868 225.085 257.246 224.074 255.45 223.284Z",
    fill: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.543 212.433L267.683 205.433C267.683 205.433 252.476 159.971 230.405 105.374C208.335 50.7778 183 0 183 0H117.644C117.644 0 145.811 64.2315 177.366 116.725C208.921 169.219 244.543 212.433 244.543 212.433Z",
    fill: "#56919c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.117 0C118.104 43.6542 104.577 99.4275 103.301 101.149C102.45 102.296 71.8127 112.562 11.3899 131.947L13.9818 142.528C86.0359 132.132 124.002 124.066 127.881 118.331C133.699 109.728 162.749 41.7631 174 0H125.117Z",
    fill: "#d4a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pant",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6294 122.8L37.1948 139.842C91.087 144.569 124.108 141.153 136.258 129.596C148.407 118.039 162.254 74.84 177.799 0H115.478C105.629 61.2839 100.123 93.2121 98.96 95.7848C97.7966 98.3574 75.6864 107.363 32.6294 122.8Z",
    fill: "#89c5cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left [shoe]"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9311 130.074C16.2095 128.937 15.5182 127.765 14.3648 127.563C12.2611 127.195 9.12692 126.756 7.45574 127.05C4.7919 127.52 -0.162158 129.309 -0.162158 129.309C0.382733 132.399 9.63191 184.854 9.63191 184.854C9.63191 184.854 17.1715 185.757 16.9197 180.991C16.6679 176.226 16.5838 173.059 16.5838 173.059L23.5408 145.213C23.6774 144.667 23.3357 144.115 22.7854 143.994L18.4673 143.044C18.4673 143.044 15.691 139.081 15.215 136.381C14.9252 134.738 15.4647 131.98 15.9311 130.074Z",
    fill: "#E4E4E4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Upper Body",
    transform: "translate(22 82) scale(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upper Body/Turtle Neck"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SKIN",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.398 149.908C46.3285 143.963 60.9699 67.4497 60.9699 67.4497L82.8673 67.5319C82.8673 67.5319 57.8506 148.583 56.308 152.406C54.3041 157.372 57.708 164.587 60.0162 169.48C60.3733 170.237 60.7041 170.938 60.9847 171.567C57.782 173 56.2435 171.268 54.6216 169.442C52.7896 167.379 50.8512 165.197 46.288 167.32C44.525 168.14 42.8567 169.109 41.2269 170.057C35.5969 173.329 30.4249 176.336 23.3891 171.994C22.2737 171.306 21.0514 168.715 24.0047 166.69C31.3624 161.645 41.9654 152.815 43.398 149.908ZM227.821 120.095L199.493 92.4604L190.084 108.74L219.542 126.108C226.928 137.743 231.266 142.77 232.556 141.19C233.643 139.857 233.145 138.396 232.686 137.051C232.328 136.003 231.994 135.025 232.453 134.231C233.5 132.42 239.414 133.457 244.984 134.682C250.554 135.906 249.265 133.17 248.081 131.742C242.817 127.493 236.063 123.611 227.821 120.095Z",
    fill: "#d4a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes Back",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.695 5.33206L136.342 3.84889C149.964 52.0008 219.953 84.823 224.249 102.823C225.825 109.425 221.074 112.762 223.528 114.772L212.288 123C210.385 120.779 206.323 124.841 197.841 122C189.359 119.159 127.695 62.3479 127.695 5.33206Z",
    fill: "#c5cfd6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Clothes Front",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.316 -4.72105C110.112 -4.87515 108.201 -3.21358 108.046 -1.00982L107.637 4.84783C91.3633 17.3711 51.0297 54.7932 40.5193 124.457C39.4152 131.775 41.4119 135.694 43.0072 138.826C44.0985 140.968 45.002 142.742 44.5967 144.983L59.3064 149.043C59.3064 147.389 61.1603 146.13 63.552 144.506C67.0298 142.145 71.6448 139.012 73.3512 132.767C74.9687 126.848 77.3372 119.454 80.1669 111.229C80.4341 122.122 82.5 132.14 87.0001 140.438C98.2274 161.139 163.109 138.436 169.887 117.318C173.505 106.049 168.372 96.5882 161.584 84.0754C152.967 68.1922 141.683 47.3917 142.241 11.7336L142.961 1.43166C143.115 -0.772099 141.454 -2.68352 139.25 -2.83762L112.316 -4.72105Z",
    fill: "#f2f2f2"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.a28a29503d2dd772f60d5712d25caa3f.svg";
export { ForwardRef as ReactComponent };